import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  verifyPhoneNumber: 'اكد رقم الهاتف',
  verify: 'اكد رقم الهاتف',
  updatePhoneNumber: 'تحديث رقم الهاتف',
  enterOtp: 'أدخل رمز التحقق الذي تم ارساله إلى الرقم',
  forUpdatePhoneNumber: 'لتحديث رقم هاتفك، ',
  enterUpdateNumberOtp: ' ادخل رمز التحقق الذي تم ارساله إلى رقمك الجديد ',
  phoneNotChanged: 'رقم الهاتف لم يتغير، يرجى تعديل الرقم للمتابعه.',
  invalidOtp: 'رمز التحقق غير صحيح',
  emailPlaceholder: 'أدخل بريدك الالكتروني',
  logoutFromAllDevices: 'تسجيل الخروج من جميع الأجهزة',
  logoutFromAllDevicesDescription:
    'سيتم تسجيل خروجك من جميع الأجهزة والجهاز الحالي.',
  logoutFromAllDevicesModalDescription:
    'هل انت متأكد من تسجيل الخروج من جميع الاجهزه؟',
  getOut: 'خروج',
});
